import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import RolesHelper from "./RolesHelper";
import useIsDrakkarOrg from "../../../hooks/useIsDrakkarOrg";

// [CANA-891] Route guard for Reports v2: only the Drakkar organisation opens
// it, anyone else entering the URL is redirected. Waits for /me/ first, so a
// reload on a v2 URL does not bounce a Drakkar user before the organisation
// has been read.
const DrakkarOnly = ({ children }) => {
  const synced = useSelector((state) => Boolean(state?.me?.synced));
  const isDrakkar = useIsDrakkarOrg();
  if (!synced) return null;
  return isDrakkar ? (
    children
  ) : (
    <Navigate to={RolesHelper.getRedirectPage()} replace />
  );
};

export default DrakkarOnly;
